import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { TrustBadges } from "@/components/site/TrustBadges";
import { ServicesSummary } from "@/components/site/ServicesSummary";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Reviews } from "@/components/site/Reviews";
import { About, Zone } from "@/components/site/About";
import { QuoteSection } from "@/components/site/QuoteSection";
import { Gallery } from "@/components/site/Gallery";
import { Partners } from "@/components/site/Partners";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <TrustBadges />
      <ServicesSummary />
      <BeforeAfter />
      <Gallery />
      <Reviews />
      <About />
      <Zone />
      <Partners />
      <QuoteSection />
    </main>
  );
}
